/* jshint ignore:start */

(function (window, document, $) {
	var roomImagesTrigger = $('.fn-view-room-images');
	
	if (roomImagesTrigger.length > 0) {
		roomImagesTrigger.click(viewRoomImages);
	}

	function viewRoomImages() {
		addDimmer();

		var imagesHolder = $('.room-images-wrapper');
		var closeTrigger = $('.fn-close-room-images');
		imagesHolder.addClass('images-active');

		$('.fn-room-images-slider').slick({
			slidesToShow: 1,
			centerMode: true,
			centerPadding: '60px',
			slidesToShow: 1,
			centerMode: true,
			adaptiveHeight: true,
            nextArrow: '<button type="button" class="slick-next"><span class="lnr lnr-chevron-right"></span></button>',
            prevArrow: '<button type="button" class="slick-prev"><span class="lnr lnr-chevron-left"></span></button>'			
		});

		closeTrigger.click(close);

		$(document).click(function(e) {
            if ($('.room-images-wrapper.images-active').is(e.target)) {
                close();
            }
        });

		function close() {
			imagesHolder.removeClass('images-active');
			$('.fn-room-images-slider').slick('unslick');
			removeDimmer();
		};

		/**
		 * Event functions for leaving Room Images
		 */
		$(document).keyup(function(e) {
            if ($('body').hasClass('site-dimmed')) {
                if (e.keyCode === 27) {
                    close();
                }
            }
        });
	}

	// Home video
	function vidInit() {
		vidOnResize();

		// Play video on hover
		$('.fn-home-video').bind({
			mouseenter: function() {
				$(this).find('video')[0].play();
			},
			mouseleave: function() {
				$(this).find('video')[0].pause();
			}
		});		
	}

	function vidOnResize() {
		var cont = $('.fn-home-video').parent();
		var contW = cont.width();
		var contH = cont.height();
		var videoElem = $('.fn-home-video').find('video');

		var vid_w, vid_h;
		var ratio = contW / contH;
		
		if (ratio >= 16 / 9) {
			vid_w = contW;
			vid_h = contW * (9 / 16);
		} else {
			vid_h = contH;
			vid_w = contH * (16 / 9);
		}

		var deltaX = (contW - vid_w) / 2;
		var deltaY = (contH - vid_h) / 2;
		
		videoElem.css({
			top: deltaY + 'px',
			left: deltaX + 'px',
			//width: contW,
			width: 'auto', // TEMP FIX?
			height: contH,
			'min-width': 'auto',
			'min-height': 'auto',
			'-webkit-transform': 'none',
			'-ms-transform': 'none',
			'transform': 'none'
		});
	}

	if ($('.fn-home-video').length > 0) {
		vidInit();

		$(window).on('resize', vidOnResize);
	}

	// Images & videos page
	if ($('.fn-selma-media-page')) {
		doMediaPage();
	}

	function doMediaPage() {
		var $slider = $('.fn-selma-media-image-slider');
		$slider.slick({
			fade: true,
			adaptiveHeight: true,
			appendArrows: $('.fn-selma-media-pagination'),
			nextArrow: '<button type="button" class="slick-next"><span class="lnr lnr-chevron-right"></span></button>',
        	prevArrow: '<button type="button" class="slick-prev"><span class="lnr lnr-chevron-left"></span></button>'
		});

		// Pagination
		$('.fn-selma-media-pagination-number').html('1');
		$slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
			$('.fn-selma-media-pagination-number').html(nextSlide+1);
		});

		// Videos
		$('.selma-media__videos__wrapper').click(function() {
			var mp4 = $(this).find('.selma-media__videos__wrapper--video').attr('data-mp4');
			var webm = $(this).find('.selma-media__videos__wrapper--video').attr('data-webm');
			var $video; 

			addDimmer();

			$('body').append(
				'<div class="selma-video-takeover-wrapper">' +
					'<span class="lnr lnr-cross selma-video-takeover-close"></span>' +
					'<div class="selma-video-takeover"></div>' +
				'</div>'
			);

			$('.selma-video-takeover-wrapper').css({
				'opacity': '1',
				'visibility': 'visible'
			});

			// Create video
			$video = '<video controls>';
				if (webm !== '') {
					$video += '<source src="'+ webm +'" type="video/webm" />'
				}
				if (mp4 !== '') {
					$video += '<source src="'+ mp4 +'" type="video/mp4" />'
				}
			$video += '</video>';
			$('.selma-video-takeover').append($video);

			$('.selma-video-takeover-wrapper').find('video').css({
				'opacity': '1',
				'visibility': 'visible'
			});			

			function close() {
				$('.selma-video-takeover-wrapper').remove();

				$('.selma-video-takeover-wrapper').css({
					'opacity': '0',
					'visibility': 'hidden'
				});

				removeDimmer();				
			};

			$('.selma-video-takeover-close').click(function() {
				close();
			});

			$(document).keyup(function(e) {
				if ($('body').hasClass('site-dimmed')) {
					if (e.keyCode === 27) {
						close();
					}
				}
			});
		});
	}

})(window, document, jQuery);